import { makeStyles } from "@mui/styles";
import theme from "src/theme";

export const useStyles = makeStyles({
    betSelectLabelWrapper: {
        width: "100%",
        display: "flex",
        alignItems: "center",
    },
    betSelectLabelIcon: {
        width: 24,
        height: 24,
        marginRight: 8,
    },
    betSelectLabel: {
        fontWeight: 700,
        fontSize: 24,
        color: "#F5F5F5E5",
        [theme.breakpoints.down(1800)]: {
            fontSize: 22,
        },
        [theme.breakpoints.down(1600)]: {
            fontSize: 20,
        },
    },
    betSelectIcon: {
        width: "100%",
        height: "100%",
        objectFit: "contain",
    },
    betOption: {
        display: "flex",
        alignItems: "center",
        width: "100%",
        color: "rgba(245, 245, 245, 0.9)",
        padding: "10px 12px",
    },
    betOptionSelected: {
        color: "rgba(245, 245, 245, 0.9)",
        background: "rgba(0, 186, 108, 0.1)",
    },
    betDropdownOptionIcon: {
        width: 20,
        height: 20,
        opacity: 0.5,
        marginRight: 5,
    },
    betDropdownOptionIconSelected: {
        opacity: 1,
    },
    betDropdownOptionLabel: {
        fontSize: 18,
        fontWeight: 500,
        color: "rgba(245, 245, 245, 0.9)",
    },
});
